import angular from 'angular';
import moneySelectField from './moneySelectField';
import './style.scss';

export default angular
  .module('components.moneySelectField', [])
  .component('moneySelectField', moneySelectField).name;
